import { useEffect, useState } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { CancelOutlined } from '@mui/icons-material';

import { getThemeColor } from '../../utils/common';
import { FORTA_BLUE, FORTA_WHITE } from '../../utils/colors';
import { Themes } from '../../constants';

import type { MouseEvent } from 'react';
import type { IFilterChip } from '../../utils/types';

interface IFHFilterChipsProps {
  colorTheme?: Themes;
  chipData: IFilterChip[];
  chipStyles?: any;
  onClick?: (id: number | string) => void;
  onChipRemove: (data: IFilterChip[]) => void;
}

const FHFilterChips = ({
  chipData,
  colorTheme = Themes.Primary,
  chipStyles = {},
  onClick,
  onChipRemove,
}: IFHFilterChipsProps) => {
  const [chips, setChips] = useState<IFilterChip[]>([]);

  useEffect(() => {
    setChips(chipData);
  }, [chipData]);

  const handleChipDelete = (e: MouseEvent<any>, id: number | string, filterName: string) => {
    e.stopPropagation();
    e.preventDefault();
    const updatedData: IFilterChip[] = chips.filter(
      (chip) => !(chip.id === id && chip.filterName === filterName),
    );
    setChips(updatedData);
    onChipRemove(updatedData);
  };

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
      {chips.map((data) => (
        <Box
          key={`${data.id}-${data.filterName}`}
          sx={{
            display: 'flex',
            backgroundColor: FORTA_WHITE,
            mr: 1,
            px: 2,
            py: 0.5,
            border: `2px solid ${FORTA_BLUE.light3}`,
            color: getThemeColor(colorTheme).primary,
            borderRadius: '20px',
            ...chipStyles,
            cursor: onClick ? 'pointer' : 'text',
          }}
          onClick={() => {
            if (onClick) {
              onClick(data.id);
            }
          }}
        >
          <Typography fontWeight={500} mr={1}>
            {data.label}
          </Typography>
          {!data.disableDelete && (
            <IconButton
              sx={{ p: 0, '&:hover': { backgroundColor: 'transparent !important' } }}
              onClick={(e) => handleChipDelete(e, data.id, data.filterName)}
            >
              <CancelOutlined style={{ color: getThemeColor(colorTheme).primary }} />
            </IconButton>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default FHFilterChips;
